<template>
  <transition name="fade">
    <header class="nav" v-if="show">
      <div class="container">
        <router-link to="/"><img src="@/assets/logo_white.png" alt="Logo" class="logo"></router-link>
        <router-link to="/categories" class="link">Categories</router-link>
        <router-link to="/shootings" class="link">Shootings</router-link>
        <router-link to="/contact" class="link">Contact</router-link>
      </div>
    </header>
  </transition>
</template>

<script>
import { useShowTimeout } from '../compositions/useShowTimeout'

export default {
  name: 'Header',
  setup() {
    const show = useShowTimeout(1000)

    return {
      show
    }
  }
}
</script>

<style lang="scss" scoped>
  .nav {
    position: fixed;
    z-index: 10;
    top: 2rem;
    left: 0;
    right: 0;

    .container {
      @extend %container;

      display: flex;
      align-items: center;
    }

    .logo {
      width: 80px;
    }

    .link {
      @extend %font-regular;
      @extend %link;

      letter-spacing: 0.1rem;
      font-size: 0.6em;
      margin-left: 1rem;

      &.router-link-active {
        color: $red;
      }
    }

    @media screen and (max-width: $mobile){
      top: 1rem;

      .logo {
        width: 60px;
      }
    }
  }
</style>